import { render } from "./LeaseEdit.vue?vue&type=template&id=476b8076"
import script from "./LeaseEdit.vue?vue&type=script&lang=js"
export * from "./LeaseEdit.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__